import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infection-control-montoring',
  templateUrl: './infection-control-montoring.component.html',
  styleUrls: ['./infection-control-montoring.component.css']
})
export class InfectionControlMontoringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
